import { omit } from 'lodash'
import * as React from 'react'

export const omitProps = (component: React.ElementType, blacklist: string[]): React.ElementType => {
  const Component = component
  return (props) => <Component {...omit(props, blacklist)} />
}
